// src/constants/gender.js
// New file: Centralizes gender options.

import malesIcon from '../assets/males.png';
import femaleIcon from '../assets/female.png';

export const genderOptions = [
  { value: 'male', icon: malesIcon, ar: 'ذكر', en: 'Male' },
  { value: 'female', icon: femaleIcon, ar: 'أنثى', en: 'Female' },
];